// extracted by mini-css-extract-plugin
module.exports = {"collapse":"Collapse_collapse__2O2Xl"};